var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _require = require('crypto'),
    createCipheriv = _require.createCipheriv,
    createDecipheriv = _require.createDecipheriv,
    getCiphers = _require.getCiphers;

var uint64be = require('../help/uint64be');

var timingSafeEqual = require('../help/timing_safe_equal');

var _require2 = require('../help/consts'),
    KEYOBJECT = _require2.KEYOBJECT;

var _require3 = require('../errors'),
    JWEInvalid = _require3.JWEInvalid,
    JWEDecryptionFailed = _require3.JWEDecryptionFailed;

var checkInput = function checkInput(size, iv, tag) {
  if (iv.length !== 16) {
    throw new JWEInvalid('invalid iv');
  }

  if (arguments.length === 3) {
    if (tag.length !== size / 8) {
      throw new JWEInvalid('invalid tag');
    }
  }
};

var encrypt = function encrypt(size, sign, _ref, cleartext, _ref2) {
  var keyObject = _ref[KEYOBJECT];
  var iv = _ref2.iv,
      _ref2$aad = _ref2.aad,
      aad = _ref2$aad === void 0 ? Buffer.alloc(0) : _ref2$aad;
  var key = keyObject.export();
  checkInput(size, iv);
  var keySize = size / 8;
  var encKey = key.slice(keySize);
  var cipher = createCipheriv("aes-".concat(size, "-cbc"), encKey, iv);
  var ciphertext = Buffer.concat([cipher.update(cleartext), cipher.final()]);
  var macData = Buffer.concat([aad, iv, ciphertext, uint64be(aad.length * 8)]);
  var macKey = key.slice(0, keySize);
  var tag = sign(_defineProperty({}, KEYOBJECT, macKey), macData).slice(0, keySize);
  return {
    ciphertext: ciphertext,
    tag: tag
  };
};

var decrypt = function decrypt(size, sign, _ref3, ciphertext, _ref4) {
  var keyObject = _ref3[KEYOBJECT];
  var iv = _ref4.iv,
      _ref4$tag = _ref4.tag,
      tag = _ref4$tag === void 0 ? Buffer.alloc(0) : _ref4$tag,
      _ref4$aad = _ref4.aad,
      aad = _ref4$aad === void 0 ? Buffer.alloc(0) : _ref4$aad;
  checkInput(size, iv, tag);
  var keySize = size / 8;
  var key = keyObject.export();
  var encKey = key.slice(keySize);
  var macKey = key.slice(0, keySize);
  var macData = Buffer.concat([aad, iv, ciphertext, uint64be(aad.length * 8)]);
  var expectedTag = sign(_defineProperty({}, KEYOBJECT, macKey), macData, tag).slice(0, keySize);
  var macCheckPassed = timingSafeEqual(tag, expectedTag);

  if (!macCheckPassed) {
    throw new JWEDecryptionFailed();
  }

  var cleartext;

  try {
    var cipher = createDecipheriv("aes-".concat(size, "-cbc"), encKey, iv);
    cleartext = Buffer.concat([cipher.update(ciphertext), cipher.final()]);
  } catch (err) {}

  if (!cleartext) {
    throw new JWEDecryptionFailed();
  }

  return cleartext;
};

module.exports = function (JWA, JWK) {
  ['A128CBC-HS256', 'A192CBC-HS384', 'A256CBC-HS512'].forEach(function (jwaAlg) {
    var size = parseInt(jwaAlg.substr(1, 3), 10);
    var sign = JWA.sign.get("HS".concat(size * 2));

    if (getCiphers().includes("aes-".concat(size, "-cbc"))) {
      JWA.encrypt.set(jwaAlg, encrypt.bind(undefined, size, sign));
      JWA.decrypt.set(jwaAlg, decrypt.bind(undefined, size, sign));

      JWK.oct.encrypt[jwaAlg] = JWK.oct.decrypt[jwaAlg] = function (key) {
        return (key.use === 'enc' || key.use === undefined) && key.length / 2 === size;
      };
    }
  });
};